/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Blank_DescInputs */

const en_gc_editor_blank_desc = /** @type {(inputs: Gc_Editor_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A clean sheet for a new idea.`)
};

const zh_gc_editor_blank_desc = /** @type {(inputs: Gc_Editor_Blank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一张空白表格，承载新想法。`)
};

/**
* | output |
* | --- |
* | "A clean sheet for a new idea." |
*
* @param {Gc_Editor_Blank_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_blank_desc = /** @type {((inputs?: Gc_Editor_Blank_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Blank_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_blank_desc(inputs)
	return zh_gc_editor_blank_desc(inputs)
});
export { gc_editor_blank_desc as "gc.editor.blank_desc" }